export default "__VITE_PUBLIC_ASSET__6485ac71__"